import * as _ from 'lodash';
import { createElementText, assertNonNullish } from '../helpers';
import { Utils as Utils_, Formatter, FormatterEx } from 'slickgrid';

export interface BadgeFormatterOptions {
  variant?: string;
  variantmap?: Dictionary<string>;
  variantMapSource?: 'inputValue' | 'fieldValue';
  pill?: boolean;
  dot?: boolean;
  badgeClass?: string | Function;
}

const DOT_HTML =
  '<span class="pe-1"><svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 16 16"><circle cx="8" cy="8" r="4" fill="currentColor"/></svg></span>';

export function badge<T>(opts: BadgeFormatterOptions): Formatter<T> {
  if (!opts) {
    throw new TypeError('Options is required.');
  }
  const pill = opts.pill ? 'rounded-pill ' : '';

  function getVariant(value: any, fieldValue: any) {
    let result = '';

    if (opts.variantmap) {
      result =
        opts.variantmap[
          opts.variantMapSource === 'fieldValue' ? fieldValue : value
        ];
    }

    if (!result && opts.variant) {
      result = opts.variant;
    }

    if (result) {
      result = `text-bg-${result}`;
    }

    return result;
  }

  function getBadgeClass(row: any, value: any) {
    if (_.isString(opts.badgeClass)) {
      return opts.badgeClass;
    }
    if (_.isFunction(opts.badgeClass)) {
      return opts.badgeClass(row, value);
    }
  }

  function getClassNames(value: any, fieldValue: any, data: any) {
    return _.chain([
      getVariant(value, fieldValue),
      getBadgeClass(data, value),
      pill,
      opts.dot ? 'badge-dot' : null,
    ])
      .filter((p) => !!p)
      .join(' ')
      .value();
  }

  const badgeFormatter: FormatterEx<T> = (
    row,
    cell,
    value,
    columnDef,
    data,
  ) => {
    if (value == null) {
      return '';
    }
    const field = columnDef.field;
    assertNonNullish(field, 'ColumnDefinition.field must have a value.');

    const classNames = getClassNames(
      value,
      _.get(data, field as string, null),
      data,
    );
    const dotHTML = opts.dot ? DOT_HTML : '';

    return `<span class="badge itp-badge ${classNames}">${dotHTML}${value}</span>`;
  };

  badgeFormatter.exportRawData = true;

  return badgeFormatter;
}
